import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { retag } from "@/lib/reftagger";

const GROUP_HINTS = {
  "Immediate Context": "What surrounds the verse",
  "Parallel Passages": "Same moment, other voices",
  "Old Testament Background": "Roots of the question",
  "New Testament Fulfillment": "Where it lands in Christ",
  "Thematic Connection": "Same thread, different books",
  "Prophetic Connection": "Promise and echo",
};

export default function RelatedScriptures({ groups }) {
  if (!groups?.length) return null;
  return (
    <Accordion
      type="multiple"
      defaultValue={[groups[0].group]}
      onValueChange={() => setTimeout(retag, 60)}
      className="space-y-3"
      data-testid="related-scriptures"
    >
      {groups.map((g) => (
        <AccordionItem
          key={g.group}
          value={g.group}
          className="rounded-2xl border border-border bg-card px-6 data-[state=open]:border-gold/50"
        >
          <AccordionTrigger className="py-5 hover:no-underline" data-testid={`related-group-${g.group.toLowerCase().replace(/\s+/g, "-")}`}>
            <div className="flex flex-col items-start gap-0.5 text-left">
              <span className="font-serif text-xl font-semibold text-foreground">{g.group}</span>
              <span className="font-mono text-[10px] uppercase tracking-wider text-muted-foreground">
                {GROUP_HINTS[g.group] || `${g.refs.length} passages`}
              </span>
            </div>
          </AccordionTrigger>
          <AccordionContent className="pb-6">
            <ul className="divide-y divide-border">
              {g.refs.map((r) => (
                <li key={r.reference} className="flex flex-col gap-1 py-3 sm:flex-row sm:items-baseline sm:gap-5">
                  <span
                    className="qg-reftag inline-flex shrink-0 items-center gap-1 font-mono text-sm font-semibold sm:w-44"
                    data-testid={`related-ref-${r.reference.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                  >
                    {r.reference}
                  </span>
                  <span className="text-sm leading-relaxed text-muted-foreground">{r.note}</span>
                </li>
              ))}
            </ul>
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
